<template>
  <div>
    <nav class="navbar navbar-expand-lg cu-nav mt-0" :class="{'navbar-dark':$darkmode,'navbar-light':!$darkmode}"
      style="width: 100%;">
      <router-link class="navbar-brand"  to="/">
        <img v-if="$darkmode" src="@/assets/logoForDark.svg" alt="logo" height="60">
        <img v-else src="@/assets/logo.svg" alt="logo" height="60">
      </router-link>
      <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarNavDropdown"
        aria-controls="navbarNavDropdown" aria-expanded="false" aria-label="Toggle navigation" ref="navbarNavDropdown">
        <span class="navbar-toggler-icon"></span>
      </button>
      <div class="collapse navbar-collapse mobile-cu " id="navbarNavDropdown" >
        
        <ul class="navbar-nav" style="width: 100%;">
          <li class="nav-item active" @click="togglerClick">
            <router-link to="/" class="nav-link "  active-class="active" href="#"><ion-icon name="home-outline" size="small"></ion-icon>
            {{$t('home')}}
            </router-link>
          </li>
          <li class="nav-item" @click="togglerClick">
            <router-link to="/categories" class="nav-link" active-class="active font-weight-bold" href="#"><ion-icon name="grid-outline" size="small"></ion-icon>
              {{$t('categories')}} </router-link>
          </li>
          <li class="nav-item" v-if="$store.getters['auth/isLoggedIn']" @click="togglerClick">
            <router-link to="/upload" class="nav-link" active-class="active font-weight-bold" href="#"><ion-icon name="cloud-upload-outline" size="small"></ion-icon> {{$t('upload')}}
            </router-link>
          </li>
           <li class="nav-item" @click="togglerClick">
            <router-link to="/photographers" class="nav-link" active-class="active font-weight-bold" href="#"><ion-icon name="camera-outline" size="small"></ion-icon> المصورون
            </router-link>
          </li>
          
           
          <div v-if="$store.state.options && $store.state.options.navs">
           <li class="nav-item"  v-for="nav in $store.state.options.navs" :key="nav.title">
            <router-link :to="nav.path" class="nav-link" active-class="active font-weight-bold" href="#"><ion-icon :name="nav.icon" size="small"></ion-icon> {{nav.title}}
            </router-link>
          </li> 
          
          </div>
          <li class="nav-item" v-if="$store.state.options.moharam" @click="togglerClick">
            <router-link class="nav-link   " to="/category/anniversary?sub=MTUz" active-class="active font-weight-bold">{{'صور زيارة الأربعين'}}</router-link>
          </li>
          

          
        </ul>
        <div class="sidebar d-md-none">
      <div class="sociall">
        <div class="d-flex justify-content-around my-3 mx-1 py-2">
          
          <a href="https://www.facebook.com/pic.imamhussain.org" target="_blank" class="fs22">
            <ion-icon name="logo-facebook"></ion-icon>
          </a>
          <a href="https://www.instagram.com/pic_imamhussainorg" target="_blank" class="fs22">
            <ion-icon name="logo-instagram" ></ion-icon>
          </a>
          <a href="https://t.me/photograph112" target="_blank" class="fs22">
            <ion-icon name="paper-plane-outline"></ion-icon>
          </a>
          <a href="https://www.tiktok.com/@pic.imamhussainorg" target="_blank" class="fs22">
            <ion-icon name="logo-tiktok"></ion-icon>
          </a>
        </div>
      </div>
    </div>
        <hr>
        <ul class="navbar-nav ml-auto mx-2 align-items-center icon-mobile-cu">
          <li class="nav-item dropdown" v-if="$store.getters['auth/isLoggedIn']" style="width: 180px;">
            <a class="nav-link d-flex align-items-center" href="#" id="navbarDropdownMenuLink" role="button"
              data-toggle="dropdown" aria-expanded="true">
              <vs-avatar circle size="36">
                <img  v-if="JSON.parse($store.state.auth.userInfo).avatar"
                                            :src="`https://pic.imamhussain.org/avatars/small/${JSON.parse($store.state.auth.userInfo).avatar}`"
                                            alt="user-avatar" style="object-fit: cover;" />
                                        <img v-else
                                        :src="`https://ui-avatars.com/api/?name=${JSON.parse($store.state.auth.userInfo).name}&length=1&bold=true&background=random`"  height="200"
                                        alt="user-avatar" style="object-fit: cover;">
              </vs-avatar>
              <div class="mx-2 font-weight-bold">{{JSON.parse($store.state.auth.userInfo).name }} </div>
            </a>
            <div class="dropdown-menu text-right" aria-labelledby="navbarDropdownMenuLink">
              <router-link   class="dropdown-item text-center cursor-pointer" :to="{name:'profile',params:{id:JSON.parse($store.state.auth.userInfo).id}}"> الملف الشخصي</router-link>
              <router-link class="dropdown-item text-center cursor-pointer"  :to="'/settings'">اعدادات الحساب</router-link>
              <a class="dropdown-item bg-danger text-center cursor-pointer" @click="$store.dispatch('auth/logout')">
                <span class="text-white">تسجيل خروج</span>
              </a>
            </div>
          </li>
          <li class="nav-item dropdown mx-1" v-if="!$store.state.options.moharam">
            <span @click="$darkmode=!$darkmode" style="cursor: pointer;">
              <vs-tooltip bottom>
                <div class="animate__animated animate__fadeInUp" v-if="$darkmode">
                  <ion-icon name="sunny-outline"></ion-icon>
                </div>
                <template #tooltip>
                  الوضع الفاتح
                </template>
              </vs-tooltip>
              <vs-tooltip bottom>
                <div class="animate__animated animate__fadeInUp" v-if="!$darkmode">
                  <ion-icon name="moon-outline"></ion-icon>
                </div>
                <template #tooltip>
                  الوضع الليلي
                </template>
              </vs-tooltip>
            </span>
          </li>

          <li class="nav-item dropdown mx-1">
            <vs-tooltip bottom>
              <div class="animate__animated animate__fadeInUp cursor-pointer" @click="search=!search">
                <ion-icon name="search-outline"></ion-icon>
              </div>
              <template #tooltip>
                بحث
              </template>
            </vs-tooltip>

            <vs-dialog   scroll overflow-hidden width="80vw" v-model="search">
              <template #header>
                <h4 class="not-margin">
                  بحث <b>في المكتبة الصورية</b>
                </h4>
              </template>


              <Search :q="q" @close="search=false"/>
            </vs-dialog>

          </li>
          <li class="mx-1" v-if="!$store.getters['auth/isLoggedIn']">
            <vs-tooltip bottom>
              <ion-icon name="person-outline" class="cursor-pointer animate__animated animate__fadeInUp"
                @click="$router.push('/login')"></ion-icon>
              <template #tooltip>
                تسجيل الدخول
              </template>
            </vs-tooltip>

          </li>
          <li class="mx-1" v-if="$store.getters['auth/isLoggedIn'] && JSON.parse($store.state.auth.userInfo).level ==1" >
            <vs-tooltip bottom>
              <a href="https://pic.imamhussain.org/index.php/admin" target="_blank" class="text-dark">
                  <ion-icon class="cursor-pointer animate__animated animate__fadeInLeft" name="cog-outline">
                  </ion-icon>
              </a>
            
              <template #tooltip>
                لوحة التحكم
              </template>
            </vs-tooltip>
          </li>



        </ul>
      </div>
    </nav>
    <div class="sidebar d-none d-md-block">
      <div class="social">
        <div class="d-flex flex-column">
          <a href="https://www.facebook.com/pic.imamhussain.org" target="_blank" class="fs22">
            <ion-icon name="logo-facebook"></ion-icon>
          </a>
          <a href="https://www.instagram.com/pic_imamhussainorg" target="_blank" class="fs22">
            <ion-icon name="logo-instagram" ></ion-icon>
          </a>
          <a href="https://t.me/photograph112" target="_blank" class="fs22">
            <ion-icon name="paper-plane-outline"></ion-icon>
          </a>
          <a href="https://www.tiktok.com/@pic.imamhussainorg" target="_blank" class="fs22">
            <ion-icon name="logo-tiktok"></ion-icon>
          </a>
        </div>
      </div>
    </div>
  </div>
</template>
<style lang="scss">
  .navbar {
    position: absolute !important;
    z-index: 1000 !important;
  }
</style>
<script>
  import Search from '../views/Search.vue'
  export default {
    components: {
      Search
    },
    data() {
      return {
        search: false,
        q:null
      }
    },
   
    mounted() {
    window.addEventListener("scroll", function() {
      var nav = document.querySelector("nav");
      if (window.scrollY > 50) {
        nav.style.backgroundColor = "#000"; 
      } else {
        nav.style.backgroundColor = "#00000000"; 
      }
    });
  },
    methods:{
    togglerClick(){
        this.$refs.navbarNavDropdown.click();
    }
} 
  }
</script>
 